
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billofsale/create",
      function () {
        return require("private-next-pages/billofsale/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/billofsale/create"])
      });
    }
  